import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ContentProvider } from './lib/content';
import { Toaster } from './components/ui/sonner';
import { ScrollToTop } from './components/ScrollToTop';
import { PublicLayout } from './components/PublicLayout';
import Home from './pages/Home';
import Trucks from './pages/Trucks';
import TruckDetail from './pages/TruckDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import AdminLogin from './admin/Login';
import { AdminLayout } from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import VehiclesAdmin from './admin/VehiclesAdmin';
import VehicleForm from './admin/VehicleForm';
import Enquiries from './admin/Enquiries';
import SettingsPage from './admin/SettingsPage';
import SiteContentAdmin from './admin/SiteContentAdmin';
import AuditLog from './admin/AuditLog';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <ContentProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/trucks" element={<Trucks />} />
            <Route path="/trucks/:slug" element={<TruckDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="vehicles" element={<VehiclesAdmin />} />
            <Route path="vehicles/new" element={<VehicleForm />} />
            <Route path="vehicles/:id/edit" element={<VehicleForm />} />
            <Route path="enquiries" element={<Enquiries />} />
            <Route path="content" element={<SiteContentAdmin />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster position="top-right" richColors />
    </HelmetProvider>
  );
}

export default App;
